import styled from 'styled-components';
import DeviceCard from '../DeviceCard';
import { Card } from '@material-ui/core';
import {useDashboardContext} from '../context/dashboard.context';

const CardContainerRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

const CardContainer = styled.div`
  width: 32.5%;
`

export const DeviceCardsContainer = ({openDetailPopup, pageName='dashboard'}) => {
  const {availableCount, inUseCount, missingCount, selectedCard, setSelectedCard} = useDashboardContext()
  const onCardSelect = (state) => {
    setSelectedCard(state)
    openDetailPopup(state)
  };

  return (
    <CardContainerRow>
      <CardContainer>
        <Card onClick={() => onCardSelect('available')} style={{'border-radius': '12px'}}>
          <DeviceCard
            title="Available"
            count={availableCount}
            subtitle={`Mobile Computers: ${availableCount} | Peripheral: 0`}
            color={pageName === 'dashboard' ? '#00864F' : selectedCard === 'available' ? '#00864F' : '#00864F30' } 
          />
        </Card>
      </CardContainer>
      <CardContainer>
        <Card onClick={() => onCardSelect('inUse')} style={{'border-radius': '12px'}}>
          <DeviceCard
            title="In use"
            count={inUseCount}
            subtitle={`Mobile Computers: ${inUseCount} | Peripheral: 0`}
            color={pageName === 'dashboard' ? '#0073E6'  : selectedCard === 'inUse' ? '#0073E6' : '#0073E630' } 
          />
        </Card>
      </CardContainer>
      <CardContainer>
        <Card onClick={() => onCardSelect('missing')} style={{'border-radius': '12px'}}>
          <DeviceCard
            title="Missing"
            count={missingCount}
            subtitle={`Mobile Computers: ${missingCount} | Peripheral: 0`}
            color={pageName === 'dashboard' ? '#B50012' : selectedCard === 'missing' ? '#B50012' : '#B5001230' } 
          />
        </Card>
      </CardContainer>
    </CardContainerRow>
  );
}
